<template>
  <side-panel-inner
    :headerTitle="`${editMode ? 'Edit' : 'Add a'} Quick Link`"
    class="p-link-create"
  >
    <template slot="actions">
      <base-button @click="onDelete" danger v-if="editMode">Delete</base-button>
      <base-button @click="onSubmit" :primary="true">{{editMode ? 'Update' : 'Create'}}</base-button>
    </template>

    <!-- User Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <loading v-if="loading"></loading>
    <form method="post" v-on:submit.prevent="onSubmit" @keyup.enter.exact="onSubmit" v-else>
      <form-field
        full-width
        label="Name"
        required
        v-model="currentLink.name"
        v-validate="{required: true}"
        data-vv-as="name"
        name="name"
        :error="errors.first('name')"
      ></form-field>

      <form-field
        full-width
        label="Link"
        required
        v-model="currentLink.url"
        v-validate="{required: true}"
        data-vv-as="url"
        name="url"
        :error="errors.first('url')"
      ></form-field>
    </form>
  </side-panel-inner>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "UserLinkAddEdit",

  data() {
    return {
      showValidationMessage: false,
      loading: true,
      editMode: false
    };
  },

  beforeMount() {
    if (this.$route.params.id) {
      this.$store
        .dispatch("users/getQuickLink", this.$route.params.id)
        .then(resp => {
          this.editMode = true;
          this.loading = false;
        });
    } else {
      this.$store.dispatch("users/resetLink").then(resp => {
        this.editMode = false;
        this.loading = false;
      });
    }
  },

  methods: {
    onDelete() {
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store.dispatch("users/removeQuickLink", this.$route.params.id);
        }
      });
    },
    onSubmit() {
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          const vm = this;
          this.loading = true;

          let action = "users/addQuickLink";
          let payload = this.currentLink;

          if (this.editMode) {
            action = "users/editLink";
            payload = { payload: this.currentLink, id: this.$route.params.id };
          }

          this.$store
            .dispatch(action, payload)
            .then(resp => {
              this.$store.dispatch(
                "notifications/create",
                {
                  body: `Your quick links have been updated`,
                  type: "success"
                },
                { root: true }
              );
              this.$store.dispatch("CLOSE_PANEL");
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },

  computed: {
    ...mapState("users", ["currentLink"]),
    formIsValid() {
      return this.user.name;
    }
  }
};
</script>
